export default __webpack_public_path__ + "static/about-nav-e5c101550413c1267142857603d74967.svg";